export default {
  mini: true,
  field_log: false,
  field: "",
  work_sources: [],
  request_sources: [],
  works_list: [],
  request_class: [],
  rejection_list: [],
  selected_products: [],
  salary_sources: [],
  cities: [],
  projects: [],
  app_products: [],
  bcItems: [],
  funding_sources: [],
  madany_works: [],
  askary_works: [],
  request_info: {},
  quality_request_info: {},
  military_ranks: [],
  military_works: [],
  request_statuses: [],
  agent_customers: [],
  search_result: [],
  quality_search: false,
  search_model: false,
  search_rate: false,
  search_rate_result: [],
  selected_customers: [],
  search_result_visibility: false,
  search_rate_result_visibility: false,
  user: "",
  cardsStyle: true,
  elements: [],
  fieldCount: 0,
  navbarUnreadCountNum: 0,
  navbarRooms: [],
  newSupport: null,
  pageNumber: 1,
  supportCount: 0,
  recievedCount: 0,
  latestCount: 0,
  activeSnack:false,
  showCards: true,
  search_admin:false,
  openDialog: false,
  turnuserDialog:false,
  TransferFilterDialog:false,
  turnToQualityDialog: false,
  allRequests: [],
  tableData: [],
  isSearch: false,
  bodySearch: {},
  loadingData: false,
  back: false,
  loggedIn: false,
  salesmanager_agents: [],
  salesmanager_agents_search: [],
  startElement: [],
  needToAddNewFilter: false,
  InfinityPageNumber: 1,
  requestId: null,
  searchedCount: null,
  openDialogMargeUsers: false,
  pagination: {},
  allQualityUser: [],
  dialogQuality: false,
  AgentSendPaymentDialog: false,
  SMSendMorPurDialog: false,
  SMRejectMorPurDialog: false,
  SMSendPaymentDialog: false,
  SMRejectPaymentDialog: false,
  QualityQuestionsDialog: false,
  QualityQuestionsDialogReqID: 0,
  freezingSearch: false,
  url: 'https://api.alwsatarealestate.com/api',
  allStatusAgent: [],
  selectId: null,
  freezeActionIsDone:true,
  waitingNewFilter: false,
  openConditionDialog: false,
  refuseDialog: false,
  refusedId: null,
  NeedToMoveQualityNewSearch: false,
  chatStatus: "all",
  opened: null,
  quality_classifications: [],
  quality_ticket_statuses: [],
  details_active_room: {},
  details_active_room_id: '',
  orderRequestDialog: false,
  orderRequestId: null,
  openOrderRequestSection: false,

  freezeData: [],
  freezeSearch: [],
  freezeLoading: false,
  latestData: [],
  latestSearch: [],
  latestLoading: false,
  allSearch: [],
  allLoading: false,
  allData: [],
  recievedSearch: [],
  recievedLoading: false,
  recievedData: [],
  followSearch: [],
  followLoading: false,
  followData: [],
  featureSearch: [],
  featureLoading: false,
  featureData: [],
  archiveData: [],
  archiveSearch: [],
  archiveLoading: false,
  needNewData: [],
  needNewSearch: [],
  needNewLoading: false,
  waitingNewData: [],
  waitingNewSearch: [],
  waitingNewLoading: false,
  needTurnNewData: [],
  needTurnNewSearch: [],
  needTurnNewLoading: false,
  FilterRateDialog: false,
  ratesInAdmin: [],
  tasksRequestId: null,
  openTasksRequestSection: false,
  tasksDetailsRequestId: null,
  openTasksDetailsRequestSection: false,
  openTiket: false,
  openAddTaskForRequest : false,
  qualityObjFilter: {},
};
